import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSmsDripSequences as GetSmsDripSequencesQuery,
    SmsDripSequenceFragment as SmsDripSequence,
    GetSmsDripSequencesVariables as GetSmsDripSequencesQueryVariables,
} from 'nutshell-graphql-types';

import GET_SMS_DRIP_SEQUENCES from '../queries/get-sms-drip-sequences.graphql';

export const useGetSmsDripSequences = (
    variables: GetSmsDripSequencesQueryVariables
): {
    smsDripSequences: SmsDripSequence[];
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {data, error, loading} = useQuery<
        GetSmsDripSequencesQuery,
        GetSmsDripSequencesQueryVariables
    >(GET_SMS_DRIP_SEQUENCES, {
        variables: variables,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    const smsDripSequencesData = data ? data.smsDripSequences : null;

    const smsDripSequences = smsDripSequencesData
        ? smsDripSequencesData.edges.map((dripSequence: {node: any}) => {
              return dripSequence.node;
          })
        : [];

    return {
        smsDripSequences,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
